export default "__VITE_ASSET__BLLooB7$__"